import React from 'react'
import './OrangeButton.scss'

function OrangeButton(props) {
  
  return (
    <a href={props.href}>
    <button className='blue-button2'>
        <span className='button-text2'>{props.text}</span>
    </button>
    </a>
  )
}

export default OrangeButton